import * as type from './actionTypes';

export const getAllConfigsAction = () => ({
  type: type.GET_ALL_CONFIGS,
});

export const setAllConfigsAction = (configs) => ({
  type: type.SET_ALL_CONFIGS,
  configs,
});

export const setConfigAction = (cycleId, rank, enabled) => ({
  type: type.SET_CONFIG,
  cycleId,
  rank,
  enabled,
});

export const setLoadingAction = (loading) => ({
  type: type.SET_LOADING,
  loading,
});

export const getAllCyclesAction = () => ({
  type: type.GET_ALL_CYCLES,
});

export const setAllCyclesAction = (cycles) => ({
  type: type.SET_ALL_CYCLES,
  cycles,
});
